import type { MonthlyModuleStatusEntity } from "../entities/BooksHealthEntity";
import type { BooksHealthRepository } from "../repositories/BooksHealthRepository";

export class GetBooksHealthMonthlyModuleStatusUseCase {
  constructor(private repository: BooksHealthRepository) {}

  async execute(): Promise<MonthlyModuleStatusEntity[]> {
    return this.repository.getBooksHealthMonthlyModuleStatus();
  }
}

